"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
require.context("../../images", true);
import { DirectUpload } from "@rails/activestorage";
import { NytieUploads } from "./nytie_uploads.mjs";
import { NytieRegistrationEmail, NytieRegistrationValidation } from "./nytie_registration.mjs";
import { initializeDiscussion } from "./nytie_discussion.mjs";
document.addEventListener("DOMContentLoaded", () => initializeDiscussion());
if (document.readyState !== "loading") initializeDiscussion();
const initializeNytieRegistration = () => {
  document.querySelectorAll("[data-nytie-registration-email]").forEach((field) => {
    if (field.dataset.initialized) return;
    field.dataset.initialized = "true";
    field.nytieValidator = new NytieRegistrationEmail(field);
  });
  document.querySelectorAll("form[data-nytie-password-url]").forEach((form) => {
    if (form.dataset.nytieInitialized) return;
    form.dataset.nytieInitialized = "true";
    new NytieRegistrationValidation(form);
  });
};
document.addEventListener("turbo:load", initializeNytieRegistration);
document.addEventListener("DOMContentLoaded", initializeNytieRegistration);
if (document.readyState !== "loading") initializeNytieRegistration();
const uploadNytieFile = (file, options) => __async(null, null, function* () {
  const labels = JSON.parse(options.labels);
  const blob = yield new Promise((resolve, reject) => {
    new DirectUpload(file, options.uploadUrl).create((error, result) => {
      if (error) reject(new Error(labels.failed));
      else resolve(result);
    });
  });
  const params = new URLSearchParams({
    resourceClass: "Decidim::Attachment",
    property: "file",
    blob: blob.signed_id,
    formClass: options.formClass
  });
  const response = yield fetch(`${options.validationUrl}?${params}`, {
    method: "POST",
    headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content }
  });
  if (!response.ok) throw new Error(labels.failed);
  const errors = Object.values(yield response.json()).flat();
  if (errors.length) throw new Error(errors.join(" "));
  return blob.signed_id;
});
const initializeNytieUploads = () => {
  document.querySelectorAll("[data-nytie-uploads]").forEach((element) => {
    if (element.dataset.initialized) return;
    element.dataset.initialized = "true";
    new NytieUploads(element, uploadNytieFile);
  });
};
document.addEventListener("decidim:loaded", initializeNytieUploads);
document.addEventListener("DOMContentLoaded", initializeNytieUploads);
if (document.readyState !== "loading") initializeNytieUploads();
document.addEventListener("ajax:error", (event) => {
  var _a, _b, _c, _d;
  if (!((_b = (_a = event.target).querySelector) == null ? void 0 : _b.call(_a, "[data-proposal-vote-button]"))) return;
  const message = (_d = (_c = event.detail) == null ? void 0 : _c[0]) == null ? void 0 : _d.error;
  if (!message) return;
  const container = event.target.closest(".card__proposals-votes-container");
  if (!container) return;
  const result = event.detail[0];
  if (result.remaining_votes === 0) {
    container.dataset.voteExhausted = "true";
    document.querySelectorAll('[data-proposal-vote-button="true"]:not([id^="vote_button-"])').forEach((button) => {
      button.disabled = true;
    });
    document.querySelectorAll("[data-remaining-votes-message]").forEach((label) => {
      label.textContent = result.remaining_votes_message;
    });
    document.querySelectorAll("[data-remaining-votes-value]").forEach((counter) => {
      counter.dataset.remainingVotesValue = "0";
    });
  }
  let alert = container.querySelector('[role="alert"]');
  if (!alert) {
    alert = document.createElement("p");
    alert.setAttribute("role", "alert");
    container.append(alert);
  }
  alert.textContent = message;
  if (result.remaining_votes === 0) alert.dataset.voteQuotaError = "true";
});
document.addEventListener("ajax:beforeSend", (event) => {
  var _a, _b;
  if (!((_b = (_a = event.target).querySelector) == null ? void 0 : _b.call(_a, "[data-proposal-vote-button]"))) return;
  event.target.addEventListener("ajax:complete", () => {
    queueMicrotask(() => {
      const counter = document.querySelector("[data-remaining-votes-value]");
      if (Number(counter == null ? void 0 : counter.dataset.remainingVotesValue) > 0) {
        document.querySelectorAll("[data-vote-quota-error]").forEach((alert) => alert.remove());
      }
    });
  }, { once: true });
});
document.addEventListener("ajax:complete", (event) => {
  var _a, _b;
  const exhaustedContainer = (_b = (_a = event.target).closest) == null ? void 0 : _b.call(_a, "[data-vote-exhausted='true']");
  if (exhaustedContainer) {
    delete exhaustedContainer.dataset.voteExhausted;
    queueMicrotask(() => {
      document.querySelectorAll('[data-proposal-vote-button="true"]:not([id^="vote_button-"])').forEach((button) => {
        button.disabled = true;
      });
    });
  }
});
